/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { OrgMembershipSummaryRole } from './orgMembershipSummaryRole';

export interface OrgMembershipSummary {
  workos_org_id: string;
  org_id?: string | null;
  org_name: string;
  logo_url?: string | null;
  role: OrgMembershipSummaryRole;
  membership_id?: string | null;
  is_active_context?: boolean;
}
